<template>
	<v-container fluid>
		<v-card>
			<v-card-title>
				<v-icon
					icon="$fileAccount"
					start
				/>
				<translate>Role</translate>: <translate>{{ role.name }}</translate>
			</v-card-title>

			<v-card-item>
				<v-card-subtitle>
					<translate>Corresponding permissions</translate>
				</v-card-subtitle>
				<v-card-text>
					<v-row>
						<v-col>
							<v-text-field
								v-model:model-value="permissionFilter"
								class="flex-shrink-1 flex-grow-0"
								:label="$gettext('Search for permission')"
								single-line
								hide-details
								variant="outlined"
								append-inner-icon="$search"
							/>
						</v-col>
						<v-spacer />
					</v-row>
					<v-row no-gutters>
						<v-col>
							<v-data-table
								:items="permissions"
								:headers="headers"
								:search="permissionFilter"
								:items-per-page="10"
								:items-per-page-options="[10, 25, 50, 100]"
							>
								<template #item.name="{item}">
									<a :href="`/bo/management/permissions/view?id=${item.id}`">
										{{ item.name }}
									</a>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card-item>
			<v-card-item>
				<v-card-subtitle>
					<translate>Users</translate>
				</v-card-subtitle>
				<v-card-text>
					<v-row>
						<v-col>
							<v-text-field
								v-model:model-value="userFilter"
								class="flex-shrink-1 flex-grow-0"
								:label="$gettext('Search for user')"
								single-line
								hide-details
								variant="outlined"
								append-inner-icon="$search"
							/>
						</v-col>
						<v-spacer />
					</v-row>
					<v-row no-gutters>
						<v-col>
							<v-data-table
								:items="users"
								:headers="usersHeaders"
								:search="userFilter"
								:items-per-page="10"
								:items-per-page-options="[10, 25, 50, 100]"
							>
								<template #item.name="{item}">
									<a :href="`/bo/users/view?id=${item.userId}`">
										{{ item.name }}
									</a>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card-item>
		</v-card>
	</v-container>
</template>

<script>
import {
	axios,
} from '../../../../services/axios-service';
export default {
	name: 'RolesView',

	data () {
		return {
			roleId: '',
			role: {
			},
			permissions: [],
			permissionFilter: '',
			users: [],
			userFilter: ''
		};
	},

	computed: {
		headers () {
			return [
				{
					title: this.$gettext('Permission name'), value: 'name', sortable: true
				},
				{
					title: this.$gettext('Created at'), value: 'createdAt', sortable: true
				},
			];
		},
		usersHeaders () {
			return [
				{
					title: this.$gettext('User'), value: 'name', sortable: true
				},
				{
					title: this.$gettext('Email'), value: 'email', sortable: true
				},
				{
					title: this.$gettext('Created at'), value: 'createdAt', sortable: true
				},
			];
		}
	},

	created () {
		this.roleId = new URLSearchParams(window.location.search.substring(1)).get('id');
	},

	mounted () {
		this.getRoleData();
		this.getUsersData();
	},

	methods: {
		/**
		 *
		 */
		getRoleData () {
			axios.get(`/api/v0/roles?id=${this.roleId}`)
				.then(({
					data
				}) => {
					if (data.length) {
						const role = data[0];

						this.role = {
							'id': role.id,
							'name': role.name
						};
						this.permissions = role.permissions;
						this.permissions.forEach((permission) => {
							const rolepermissionIndex = role.rolepermissions ? role.rolepermissions.findIndex(((element) => element.permissionId === permission.id)) : null;
							const rolepermission = rolepermissionIndex !== -1 ? role.rolepermissions[rolepermissionIndex] : null;
							const createdAt = rolepermission ? rolepermission.createdAt : null;

							permission.createdAt = createdAt ? createdAt.date : '';
						});
					}

				})
				.catch((error) => {
					window.captureException(error);
				});
		},

		/**
		 *
		 */
		getUsersData () {
			axios.get(`/api/v0/userroles?role_id=${this.roleId}`)
				.then(({
					data
				}) => {
					if (data.length) {
						data.forEach((item, index) => {
							this.users[index] = {
								'createdAt': item.createdAt.date,
								'email': item.user.email,
								'name': this.getUserName(item.user),
								'userId': item.user.id
							};
						});
					}
				})
				.catch((error) => {
					window.captureException(error);
				});
		},

		/**
		 *
		 * @param {object} user
		 * @returns {string}
		 */
		getUserName (user) {
			let name = '';

			if (user.nameFirst) {
				name = name + user.nameFirst + ' ';
			}
			if (user.nameInfix) {
				name = name + user.nameInfix + ' ';
			}
			if (user.nameLast) {
				name = name + user.nameLast;
			}
			return name;
		}
	}
};
</script>
